import { createContext } from "react";

export const TimestampContext = createContext<[time: number | undefined, setTime: (time: number) => void]>(
    [undefined, () => {}]
);
